<template>
  <sl-side-panel v-model="modalVisible" :mask-closable="false" :title="itemTitle">
    <Form class="sm" ref="form" :model="form" :rules="rules" :label-width="100">
      <FormItem label="账号类型" prop="attributes">
        <sl-select v-model="form.attributes" dict="$accountType" type="radio"></sl-select>
      </FormItem>
      <FormItem label="姓名" prop="name">
        <Input v-model="form.name" :maxlength="32"></Input>
      </FormItem>
      <FormItem label="账号" prop="account">
        <Input v-model="form.account" :maxlength="32"></Input>
      </FormItem>
      <FormItem label="手机号" prop="phone">
        <Input v-model="form.phone" :maxlength="32"></Input>
      </FormItem>
      <FormItem label="设置密码" prop="password" :rules="rulePassword">
        <Input v-model="form.password" type="password" :maxlength="18"></Input>
      </FormItem>
      <FormItem label="确认密码" prop="passwordCheck" :rules="rulePasswordCheck">
        <Input v-model="form.passwordCheck" type="password" :maxlength="18"></Input>
      </FormItem>
      <FormItem label="管理企业" prop="companyIds">
        <sl-select v-model="form.companyIds" :multiple="true" :data="companies" :filterable="true"></sl-select>
      </FormItem>
      <FormItem label="职务" prop="duties">
        <Input v-model="form.duties" :maxlength="128"></Input>
      </FormItem>
      <FormItem label="邮箱" prop="email">
        <Input v-model="form.email" :maxlength="64"></Input>
      </FormItem>
      <FormItem label="角色分配" prop="roleIds">
        <sl-select v-model="form.roleIds" :data="roles" :multiple="true" :filterable="true"></sl-select>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button :loading="loading" @click="handleSubmit('form')" type="primary">确定</Button>
    </div>
  </sl-side-panel>
</template>
<script>
import { phoneValidator } from '@/util/validator'
export default {
  components: {},
  data() {
    return {
      rules: {
        attributes: [{ type:'number',required: true, message: '请选择类型', trigger: 'blur,change' }],
        name: [{ required: true, message: '姓名不能为空', trigger: 'blur,change' }],
        //password: [{required: !this.id, validator:validatePassword, trigger: 'blur,change' }],
        //passwordCheck: [{ required: !this.id, validator:validatePasswordCheck, trigger: 'blur,change' }],
        phone: [{ required: true, validator: phoneValidator('请输入手机号', '请输入正确格式的手机号'), trigger: 'blur,change' }],
        account: [{ required: true, message: '账户不能为空', trigger: 'blur,change' }],
      },
      form: {
        id: null,
        attributes:null,
        name: null,
        phone: null,
        account: null,
        email: null,
        roleIds: null,
        companyIds: null,
        duties: null,
        password: null,
      },
      id: null,
      modalVisible: false,
      loading: false,
      isCreate: true,
      roles: [],
      companies: []
    }
  },

  created() {
    this.def = { ...this.form }
    this.$request.companies({ "search": { }, "pageSize": 1000, "pageNum": 1 }).then(resp => {
      if (!resp.code) {
        this.companies = resp.data.list.filter(i => i.id != this.id).map(i => ({
          value: i.id,
          label: i.companyName
        }))
      }
    })

    this.$request.roles({pageSize:9999,pageNum:1}).then(resp => {
      this.roles = resp.data.list.map(i => ({ value: i.id, label: i.name }))
    })
  },

  computed: {
    itemTitle() {
      return this.id ? '编辑用户' : '新增用户'
    },
    rulePassword() {
      return [{ required: !this.id, validator: this.validatePassword, trigger: 'blur,change' }]
    },
    rulePasswordCheck() {
      return [{ required: !this.id, validator: this.validatePasswordCheck, trigger: 'blur,change' }]
    }
  },


  methods: {
    validatePassword(rule, value, callback) {
      if (rule.required) {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.form.password !== '') {
            // 对第二个密码框单独验证
            this.$refs.form.validateField('passwordCheck');
          }
          callback()
        }
      } else {
        callback()
      }
    },
    validatePasswordCheck(rule, value, callback) {
      if (this.form.password) {
        if (value === '') {
          callback(new Error('请再此输入密码'))
        } else if (value !== this.form.password) {
          callback(new Error('两次密码不一致'))
        } else {
          callback();
        }
      } else {
        callback()
      }
    },
    query() {
      // this.$request.ciEnterprise(this.id).then(resp => {
      this.$request.app(this.id).then(resp => {
        this.originData = resp.data
        this.$utils.fill(this.form, resp.data)
      })
    },

    init(id) {
      this.id = id
      this.destory()
      this.modalVisible = true
      if (this.id) {
        this.query()
      }
    },
    initData(data) {
      this.id = data.id
      this.destory()
      this.modalVisible = true
      this.originData = data

      this.$utils.fill(this.form, data)
      this.form.companyIds = data.companyInfos.map( i => i.id )
      console.log(this.form.companyIds)
      this.form.roleIds = data.roles.map( i => i.id )

    },

    destory() {
      this.$utils.fill(this.form, this.def)
      this.$refs['form'].resetFields()
    },

    reset() {
      this.$utils.fill(this.form, this.originData)
      this.$refs['form'].resetFields()
    },

    save() {
      let params = { ...this.form }
      // params.roleIds = params.roleIds.map(i => ({ id: i }))
      // params.companyIds = params.companyIds.map( i => ({id:i})) 
      this.loading = true
      let exec = this.id ? this.$request.companyUserUpdate : this.$request.companyUserCreate
      exec(params).then(resp => {
        if (resp.code) {
          this.$Message.error({ content: resp.msg })
        } else {
          this.$Message.success('保存成功')
          this.$emit('on-update')
          this.modalVisible = false
        }
        this.loading = false
      })

    },

    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          this.$Message.error('参数错误');
        }
      })
    },
    handleChangeArea() {

    },
    handleClose() {
      this.$emit('on-update')
    },
  }
}

</script>
